import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import client from "../../services/Client";
import Loading from "../../components/loader/Loading";
import { useSelector } from "react-redux";
import arrowLeft from "../../asessts/Images/arrow_left.svg";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { formatRole } from "../../utils/common";
import ImagePreviewModal from "../../components/common/ImagePreviewModal";
function LaboratoryDetail() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [laboratoryDetails, setLaboratoryDetails] = useState({});
  const pageSlice = useSelector((state) => state.pageSlice.pageSlice);
  const navigate = useNavigate();
  const { state } = useLocation();
  const activeTab = state?.activeTab;
  const fetchLaboratoryDetails = async () => {
    setIsLoading(true);
    try {
      const response = await client.get(
        `/admin/healthFacility/get-laboratory/${id}`
      );
      setLaboratoryDetails(response?.data?.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching laboratory details:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLaboratoryDetails();
  }, [id]);

  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleStatusChange = async (status) => {
    if (status === "approved") {
      setIsApproving(true);
    } else {
      setIsRejecting(true);
    }

    try {
      const response = await client.put(
        `/admin/profile/change-status/${id}`,
        null,
        {
          params: { status },
        }
      );

      if (response.data.status) {
        toast.success(
          response.data.message || `Request ${status} successfully`
        );
        fetchLaboratoryDetails();
        navigate(-1);
      } else {
        toast.error(response.data.message || `Failed to ${status} request`);
      }
    } catch (error) {
      console.error(`Error ${status} request:`, error);
      toast.error(`Failed to ${status} request`);
    } finally {
      if (status === "approved") {
        setIsApproving(false);
      } else {
        setIsRejecting(false);
      }
    }
  };

  return (
    <>
      <div className="admin-dashboard">
        <Sidebar />
        <div className="main-dashboard subadmin-dashboard">
          <Header
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img
                  src={arrowLeft}
                  alt="Back"
                  style={{ cursor: "pointer", width: "22px", height: "22px" }}
                  onClick={() =>
                    navigate(-1, { state: { activeTab: activeTab } })
                  }
                />
                <span>Requests</span>
              </div>
            }
          />
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <div className="setting-main request-main">
                <div className="setting-details">
                  <div className="basic-detail">
                    <div className="profile-upload">
                      <div className="profile-img">
                        <img
                          src={laboratoryDetails?.information?.image}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="profile-details">
                      <div className="profile-head">
                        <div className="">
                          <h2>
                            {laboratoryDetails?.user?.firstName}{" "}
                            {laboratoryDetails?.user?.lastName}
                          </h2>
                          <p>
                            <span>Request ID:</span>{" "}
                            {laboratoryDetails?.profileId}
                          </p>
                        </div>
                        {pageSlice === "request" && activeTab === "Pending" && (
                          <div className="reject-approve-btn">
                            <button
                              className="reject-btn"
                              onClick={() => handleStatusChange("rejected")}
                              disabled={isRejecting || isApproving}
                            >
                              {isRejecting ? "Processing..." : "Reject"}
                            </button>
                            <button
                              className="approve-btn"
                              onClick={() => handleStatusChange("approved")}
                              disabled={isApproving || isRejecting}
                            >
                              {isApproving ? "Processing..." : "Approve"}
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Type</label>
                          <input
                            type="text"
                            placeholder="Henry"
                            value={formatRole(
                              laboratoryDetails?.facilityOrProfession
                            )}
                            readOnly
                          />
                        </div>
                        <div class="input-field">
                          <label>Role</label>
                          <input
                            type="text"
                            placeholder="Estward"
                            value={formatRole(laboratoryDetails?.role)}
                          />
                        </div>
                        <div className="input-field">
                          <label>Phone Number</label>
                          <input
                            type="text"
                            placeholder="Phone"
                            value={
                              laboratoryDetails?.user?.phoneNumber?.number
                                ? `+${laboratoryDetails?.user?.phoneNumber?.dialCode} ${laboratoryDetails?.user?.phoneNumber?.number}`
                                : ""
                            }
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Email</label>
                          <input
                            type="text"
                            placeholder="Email"
                            value={laboratoryDetails?.user?.email}
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Address</label>
                          <textarea
                            className="input-address"
                            placeholder="Address"
                            value={laboratoryDetails?.information?.address?.add}
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          {/* <label>Website</label>
                        <input
                          type="text"
                          placeholder="Website"
                          value={laboratoryDetails?.website}
                          readOnly
                        /> */}
                        </div>
                        {/* <div className="input-field">
                        <label>Accreditation</label>
                        <input
                          type="text"
                          placeholder="Accreditation"
                          value={laboratoryDetails?.accreditation}
                          readOnly
                        />
                      </div> */}
                      </div>
                      <div className="input-group">
                        {laboratoryDetails?.information?.additionalText && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Additional Text</label>
                            <textarea
                              placeholder="Description"
                              value={
                                laboratoryDetails?.information?.additionalText
                              }
                              readOnly
                            ></textarea>
                          </div>
                        )}
                        {/* <div className="input-field" style={{ width: "48%" }}>
                        <label>Tests Available</label>
                        <textarea
                          placeholder="Tests"
                          value={laboratoryDetails?.testsAvailable?.join(", ")}
                          readOnly
                        ></textarea>
                      </div> */}
                        {laboratoryDetails?.investigations && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Tests Available</label>
                            <textarea
                              placeholder="Tests"
                              value={laboratoryDetails?.investigations
                                ?.map((test) => test.type)
                                .join(", ")}
                              readOnly
                            ></textarea>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {laboratoryDetails?.investigations && (
                <div className="request-document">
                  <h3>Investigations</h3>
                  <div className="other-services-container">
                    {laboratoryDetails?.investigations &&
                    laboratoryDetails.investigations.length > 0 ? (
                      laboratoryDetails.investigations.map(
                        (investigation, index) => (
                          <div className="service-card" key={index}>
                            <h4 className="service-name">
                              {investigation.name || "Name"}
                            </h4>
                            <p className="service-desc">
                              {investigation.information || "information"}
                            </p>
                            <p>
                              <span>
                                {" "}
                                <b> Price:</b>
                              </span>{" "}
                              {investigation.price || "0"}
                            </p>
                          </div>
                        )
                      )
                    ) : (
                      <p style={{ color: "#888" }}>No services available</p>
                    )}
                  </div>
                </div>
              )}
              {laboratoryDetails?.documents && (
                <div className="request-document">
                  <h3>Professional Documents</h3>
                  <div className="doc-main">
                    <div>
                      <div className="doc">
                        <div
                          className="doc-file"
                          onClick={() =>
                            setSelectedImage(
                              laboratoryDetails?.documents?.certificate
                            )
                          }
                        >
                          <img
                            style={{ width: "100%", height: "100%" }}
                            src={laboratoryDetails?.documents?.certificate}
                            alt=""
                          />
                        </div>
                        <div className="Document-name">
                          <span>
                            {laboratoryDetails?.documents &&
                            Object.keys(laboratoryDetails.documents).length > 0
                              ? Object.keys(laboratoryDetails.documents)[0]
                              : "No document available"}
                          </span>
                        </div>
                      </div>
                      {laboratoryDetails?.documents?.license && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                laboratoryDetails?.documents?.license
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={laboratoryDetails?.documents?.license}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {laboratoryDetails?.documents &&
                              Object.keys(laboratoryDetails.documents).length >
                                1
                                ? Object.keys(laboratoryDetails.documents)[1]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {laboratoryDetails?.personalDocuments && (
                <div className="request-document">
                  <h3>Personal Documents</h3>
                  <div className="doc-main">
                    <div>
                      {laboratoryDetails?.personalDocuments?.nimc && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                laboratoryDetails?.personalDocuments?.nimc
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={laboratoryDetails?.personalDocuments?.nimc}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>NIMC</span>
                          </div>
                        </div>
                      )}
                      {laboratoryDetails?.personalDocuments?.license && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                laboratoryDetails?.personalDocuments?.license
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={
                                laboratoryDetails?.personalDocuments?.license
                              }
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>License</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {selectedImage && (
        <ImagePreviewModal
          imageUrl={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </>
  );
}

export default LaboratoryDetail;
